import { h, Host } from "@stencil/core";
export class Collapse {
    constructor() {
        this.isOpen = false;
        this.open = false;
    }
    componentWillLoad() {
        if (this.isOpen !== false) {
            this.setOpen(true);
        }
    }
    toggleOpen(event) {
        if (event.target.hasAttribute('collapse-trigger')) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.setOpen(!this.open);
        }
    }
    async setOpen(open) {
        this.open = open;
    }
    render() {
        return (h(Host, { key: '85b8e9b4a37baa3960cd3e632794b2a24e9a24be', class: { 'show': this.open } }, h("slot", { key: '6642a327a94b2830dd10039f5eebbb7e44312bde' })));
    }
    static get is() { return "uvex-collapse"; }
    static get properties() {
        return {
            "isOpen": {
                "type": "boolean",
                "attribute": "is-open",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "open": {}
        };
    }
    static get methods() {
        return {
            "setOpen": {
                "complexType": {
                    "signature": "(open: boolean) => Promise<void>",
                    "parameters": [{
                            "name": "open",
                            "type": "boolean",
                            "docs": ""
                        }],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "click",
                "method": "toggleOpen",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=collapse.js.map
